import { useState } from 'react';
import { useAuth } from '../context/AuthContext';
import toast from 'react-hot-toast';

export default function LoginPage() {
  const { login, register } = useAuth();
  const [mode, setMode] = useState('login');
  const [loading, setLoading] = useState(false);
  const [form, setForm] = useState({ name: '', email: '', password: '' });

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      if (mode === 'login') {
        await login(form.email, form.password);
        toast.success('¡Bienvenido de vuelta!');
      } else {
        await register(form.name, form.email, form.password);
        toast.success('¡Cuenta creada exitosamente!');
      }
    } catch (err) {
      toast.error(err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={styles.page}>
      {/* Background glow */}
      <div style={styles.glow1} />
      <div style={styles.glow2} />

      <div style={styles.container} className="animate-fadeIn">
        {/* Logo */}
        <div style={styles.logoWrap}>
          <div style={styles.logo}>
            <span style={{ fontSize: 28 }}>₿</span>
          </div>
          <h1 style={styles.logoText}>Finanzas</h1>
          <p style={styles.logoSub}>Tu gestor financiero personal</p>
        </div>

        {/* Tabs */}
        <div style={styles.tabs}>
          <button
            style={{ ...styles.tab, ...(mode === 'login' ? styles.tabActive : {}) }}
            onClick={() => setMode('login')}
          >
            Iniciar sesión
          </button>
          <button
            style={{ ...styles.tab, ...(mode === 'register' ? styles.tabActive : {}) }}
            onClick={() => setMode('register')}
          >
            Crear cuenta
          </button>
        </div>

        {/* Form */}
        <form onSubmit={handleSubmit} style={styles.form}>
          {mode === 'register' && (
            <div className="form-group animate-slideUp">
              <label className="form-label">Nombre completo</label>
              <input
                type="text" className="form-input"
                placeholder="¿Cómo te llamamos?"
                value={form.name}
                onChange={e => setForm({ ...form, name: e.target.value })}
                required
              />
            </div>
          )}

          <div className="form-group">
            <label className="form-label">Correo electrónico</label>
            <input
              type="email" className="form-input"
              placeholder="tu@correo.com"
              value={form.email}
              onChange={e => setForm({ ...form, email: e.target.value })}
              required
            />
          </div>

          <div className="form-group">
            <label className="form-label">Contraseña</label>
            <input
              type="password" className="form-input"
              placeholder={mode === 'register' ? 'Mínimo 6 caracteres' : '••••••••'}
              value={form.password}
              onChange={e => setForm({ ...form, password: e.target.value })}
              required
            />
          </div>

          <button
            type="submit"
            className="btn btn-primary btn-full btn-lg"
            disabled={loading}
            style={{ marginTop: 8 }}
          >
            {loading ? <span className="spinner" /> : (
              mode === 'login' ? 'Entrar a mi cuenta' : 'Crear mi cuenta'
            )}
          </button>
        </form>

        <p style={styles.footer}>
          Tus datos se almacenan de forma segura en tu servidor
        </p>
      </div>
    </div>
  );
}

const styles = {
  page: {
    minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center',
    padding: '24px', position: 'relative', overflow: 'hidden',
    background: 'var(--bg-primary)',
  },
  glow1: {
    position: 'fixed', width: 600, height: 600, borderRadius: '50%',
    background: 'radial-gradient(circle, rgba(124,111,255,0.12) 0%, transparent 70%)',
    top: '-200px', left: '-200px', pointerEvents: 'none',
  },
  glow2: {
    position: 'fixed', width: 500, height: 500, borderRadius: '50%',
    background: 'radial-gradient(circle, rgba(0,212,170,0.08) 0%, transparent 70%)',
    bottom: '-150px', right: '-150px', pointerEvents: 'none',
  },
  container: {
    width: '100%', maxWidth: 420, position: 'relative', zIndex: 1,
    display: 'flex', flexDirection: 'column', gap: 28,
  },
  logoWrap: { textAlign: 'center', display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 12 },
  logo: {
    width: 72, height: 72, borderRadius: 24,
    background: 'linear-gradient(135deg, var(--accent), #00D4AA)',
    display: 'flex', alignItems: 'center', justifyContent: 'center',
    boxShadow: '0 0 40px rgba(124,111,255,0.4)',
  },
  logoText: { fontSize: '2rem', fontWeight: 800, letterSpacing: '-0.02em' },
  logoSub: { color: 'var(--text-secondary)', fontSize: '0.9rem' },
  tabs: {
    display: 'flex', background: 'var(--bg-card)', border: '1px solid var(--border)',
    borderRadius: 'var(--radius)', padding: 4, gap: 4,
  },
  tab: {
    flex: 1, padding: '11px 16px', border: 'none', borderRadius: 12,
    background: 'transparent', color: 'var(--text-secondary)',
    cursor: 'pointer', fontFamily: 'var(--font-body)', fontSize: '0.9rem', fontWeight: 500,
    transition: 'all 0.2s',
  },
  tabActive: {
    background: 'var(--bg-card-hover)', color: 'var(--text-primary)',
    boxShadow: 'inset 0 0 0 1px var(--border)',
  },
  form: { display: 'flex', flexDirection: 'column', gap: 18 },
  footer: {
    textAlign: 'center', fontSize: '0.78rem', color: 'var(--text-muted)',
    display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 6,
  },
};
